import { Component, Input, OnInit, inject } from '@angular/core';
import { ProductDetail } from '../../generic/classes/product.detail';
import { ShipmentLine } from '../../generic/classes/shipmentline';
import { Logger } from '../../generic/logging/default-log.service';
import { ApplicationService } from '../../generic/service/application.service';
import { ShipmentLineService } from '../../generic/service/shipmentline.service';
import { CustomDatePipe } from '../../generic/pipes/custom.date.pipe';
import { DecimalPipe } from '@angular/common';

/**
 * Show the order history of the logged in customer.
 *
 * @author Jan Hartman
 */
@Component({
    selector: 'product-order-history',
    templateUrl: './product.order.history.component.html',
    styleUrls: ['./product.order.history.component.scss'],
    standalone: true,
    imports: [DecimalPipe, CustomDatePipe],
})
export class ProductOrderHistoryComponent implements OnInit {
    applicationService = inject(ApplicationService);
    private shipmentLineService = inject(ShipmentLineService);
    private logger = inject(Logger);

    @Input() limit: number;
    @Input() product: ProductDetail;
    shipmentLines: ShipmentLine[];
    showAllShipmentLines: boolean;
    showMoreEnabled: boolean;

    /**
     * Toggle between all historical shipment lines available or only given limit of lines.
     */
    toggleAllShipmentLines() {
        this.showAllShipmentLines = !this.showAllShipmentLines;
        const numberOfLines = this.showAllShipmentLines ? 100 : this.limit;

        this.getOrderHistory(
            this.product.priceListNo,
            this.product.priceListLineNo,
            numberOfLines,
        );
    }

    /**
     * Get the order history, these contain of shipmentLines with the historical data.
     */
    getOrderHistory(
        priceListNo: string,
        priceListLineNo: string,
        numberOfLines: number,
    ) {
        this.shipmentLineService
            .getShipmentLines(priceListNo, priceListLineNo, numberOfLines + 1)
            .subscribe(
                value => {
                    if (this.showAllShipmentLines) {
                        this.shipmentLines = value;
                    } else {
                        this.showMoreEnabled = value.length > numberOfLines;
                        this.shipmentLines = value.slice(0, numberOfLines);
                    }
                },
                error =>
                    this.logger.error('Failed to get order history', error),
            );
    }

    ngOnInit(): void {
        this.showAllShipmentLines = false;
        this.getOrderHistory(
            this.product.priceListNo,
            this.product.priceListLineNo,
            this.limit,
        );
    }
}
